import React,{useState, useEffect} from 'react'
import { Link } from 'react-router-dom'
import './about.css'
import Logo from '../../asset/logoFC.svg'
import crossIcon from '../../asset/crossIcon.png'
import heartEmoji from '../../asset/heartEmoji.png'
import coverFilter from '../../asset/cover.png'
import bgWithLogo from '../../asset/bgWithLogo.png'
import officeImage from '../../asset/officeImage.png'
import nasimImg from '../../asset/nasim.png'
import sadikImg from '../../asset/sadik.png'
import oyshiImg from '../../asset/oyshi.png'
import mailIcon from '../../asset/mailIcon.png'
import phoneIcon from '../../asset/phoneIcon.png'
import linkArrow from '../../asset/arrowRight.svg'
import { motion } from 'framer-motion'
import { useRef } from 'react'
import { useInView } from 'react-intersection-observer'



export default function About() {
  const [cX, setCX] = useState()
  const [cY, setCY] = useState()
  const [abtBgRef, abtBgRefInview] = useInView()
  const [nasimImgRef, nasimImgInview] = useInView()
  const [oyshiImgRef, oyshiImgInview] = useInView()
  const [nasimLeft, nasimLeftInview] = useInView()
  const [oyshiRight, oyshiRightInview] = useInView()
  const [sadikLeft, sadikLeftInview] = useInView()
  const [sadikImgRef, sadikImgInview] = useInView()
  const [teamRef, teamInview] = useInView()
  const [csLeft, csLeftInview] = useInView()
  const [csRight, csRightInview] = useInView()
  const [mailRef, mailInview] = useInView()
  const [phoneRef, phoneInview] = useInView()
  const [detailsPTagRef, detailsPTagInview] = useInView()
  const [contactCard, contactCardInView] = useInView()

  const handleMouseUpdate = (e)=>{
    setCX(e.clientX);
    setCY(e.clientY)
  }

  const varientAbt={
    imgInit:{ backgroundColor:"#8DFFA8", y:0 },
    imgInitOyshi:{ backgroundColor:"#E1FF31", y:0 },
    imgInitColor:{ backgroundColor:"#000000", y:0 },
    imgAnim:{backgroundColor:"#8DFFA8", y:"100%" },
    imgAnimOyshi:{backgroundColor:"#E1FF31", y:"100%" },
    imgAnimColor:{backgroundColor:"#000000", y:"100%" },
    imgTrans :{ duration:10 },
    theTeamInit:{y:"100%",opacity:0, rotate:'-90deg' },
    theTeamAnim:{y:0, rotate: '-90deg'},
    leftInit:{x:"-100%", opacity:0},
    leftAnim:{x:0, opacity:1},
    rightInit:{x:"100%", opacity:0},
    rightAnim:{x:0, opacity:1},
    hidden:{opacity:0},
    show:{opacity:1},
    textInit:{y:"100%", opacity:0},
    textAnim:{y:0, opacity:1},
    hidden:{opacity:0},
    show:{opacity:1}
  }

  useEffect(() => {

    const elm = document.getElementById('cursorArea')
    elm.addEventListener('mousemove', handleMouseUpdate)
    { /*window.scrollTo(0, 0)*/ }
  
    return () => {
      elm.removeEventListener('mousemove', handleMouseUpdate)
    }
  }, [])
  

  return (
    <div id='abtStart' className="aboutComponent">
        <section id='landing' className="landing">
          <div className="cursorArea" id='cursorArea'  >
            <div id='cursorIcon' className="cursorIcon" style={{left: (cX-1120) + "px", top: (cY-620) +"px"}} >
              <img className='' src={coverFilter} alt="" />
            </div>
            <div className="shownElements">
            <p id='landingPageTitle'  className="landingPageTitle">
            WELCOME TO<br />THE WOOENE <br />STUDIO. <img className='heroImgL' src={crossIcon} alt="" /></p>
            <div id='flex' className="flex"><img id='heroImgL' className='heroImgL' src={Logo} alt="" />
            <p id='landingPageTitle2' className="landingPageTitle2">made <br /><span className='m1'>with love</span> <img className="emoji" src={heartEmoji}/></p></div>
            </div>
            
          </div>
        </section>

      <section id='details' className="details">
        <div id='detailsPTag' className="detailsPTag" ref={detailsPTagRef}>
          <motion.p variants={varientAbt} animate={detailsPTagInview ? "textAnim":"textInit"}
           transition={{type:"tween", duration:.5}}>
          The Web &nbsp;
          <svg width="24" height="24" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.14999 49.07H94.3" stroke="#88FFA4" stroke-width="5.82" stroke-miterlimit="10"></path><path d="M94.3099 49.07C94.3099 58.0849 91.6368 66.8973 86.6284 74.3929C81.62 81.8885 74.5013 87.7306 66.1727 91.1804C57.844 94.6303 48.6794 95.5329 39.8378 93.7742C30.9961 92.0155 22.8745 87.6744 16.5001 81.2999C10.1256 74.9255 5.78448 66.8039 4.02576 57.9622C2.26705 49.1206 3.16967 39.9559 6.61951 31.6273C10.0694 23.2986 15.9115 16.18 23.4071 11.1716C30.9027 6.16324 39.7151 3.49 48.73 3.49C54.7156 3.49 60.6427 4.66893 66.1727 6.95954C71.7027 9.25015 76.7274 12.6076 80.9599 16.8401C85.1924 21.0726 88.5498 26.0972 90.8404 31.6273C93.131 37.1573 94.3099 43.0844 94.3099 49.07V49.07Z" stroke="#88FFA4" stroke-width="5.82" stroke-miterlimit="10"></path><path d="M70.6 49.07C70.6 74.24 60.81 94.64 48.73 94.64C36.65 94.64 26.87 74.24 26.87 49.07C26.87 23.9 36.66 3.49 48.73 3.49C60.8 3.49 70.6 23.9 70.6 49.07Z" stroke="#88FFA4" stroke-width="5.82" stroke-miterlimit="10"></path><path d="M48.73 3.49V94.64" stroke="#88FFA4" stroke-width="5.82" stroke-miterlimit="10"></path><path d="M94.31 49.07C94.31 60.59 73.9 69.94 48.73 69.94C23.56 69.94 3.16 60.59 3.16 49.07C3.16 37.55 23.56 28.19 48.73 28.19C73.9 28.19 94.31 37.54 94.31 49.07Z" stroke="#88FFA4" stroke-width="5.82" stroke-miterlimit="10"></path></svg>
          &nbsp;is curious territory. Its streets are labyrinths, its buildings constantly change places and the same language is not spoken everywhere. Not getting lost is a feat; to have fun there is a chance; settling there is a job.
          </motion.p>
          <motion.p variants={varientAbt} animate={detailsPTagInview ? "textAnim":"textInit"} transition={{type:"tween", duration:.5, delay:.3}}>
          For ten years, the web
          &nbsp;
          <svg width="24" height="24" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.14999 49.07H94.3" stroke="#88FFA4" stroke-width="5.82" stroke-miterlimit="10"></path><path d="M94.3099 49.07C94.3099 58.0849 91.6368 66.8973 86.6284 74.3929C81.62 81.8885 74.5013 87.7306 66.1727 91.1804C57.844 94.6303 48.6794 95.5329 39.8378 93.7742C30.9961 92.0155 22.8745 87.6744 16.5001 81.2999C10.1256 74.9255 5.78448 66.8039 4.02576 57.9622C2.26705 49.1206 3.16967 39.9559 6.61951 31.6273C10.0694 23.2986 15.9115 16.18 23.4071 11.1716C30.9027 6.16324 39.7151 3.49 48.73 3.49C54.7156 3.49 60.6427 4.66893 66.1727 6.95954C71.7027 9.25015 76.7274 12.6076 80.9599 16.8401C85.1924 21.0726 88.5498 26.0972 90.8404 31.6273C93.131 37.1573 94.3099 43.0844 94.3099 49.07V49.07Z" stroke="#88FFA4" stroke-width="5.82" stroke-miterlimit="10"></path><path d="M70.6 49.07C70.6 74.24 60.81 94.64 48.73 94.64C36.65 94.64 26.87 74.24 26.87 49.07C26.87 23.9 36.66 3.49 48.73 3.49C60.8 3.49 70.6 23.9 70.6 49.07Z" stroke="#88FFA4" stroke-width="5.82" stroke-miterlimit="10"></path><path d="M48.73 3.49V94.64" stroke="#88FFA4" stroke-width="5.82" stroke-miterlimit="10"></path><path d="M94.31 49.07C94.31 60.59 73.9 69.94 48.73 69.94C23.56 69.94 3.16 60.59 3.16 49.07C3.16 37.55 23.56 28.19 48.73 28.19C73.9 28.19 94.31 37.54 94.31 49.07Z" stroke="#88FFA4" stroke-width="5.82" stroke-miterlimit="10"></path></svg>
          &nbsp;
          is our playground. We know its laws by heart, itsshortcuts, its thousand jargons and its secret spots. And we've had fun with you for ten years.
          </motion.p>
          <motion.p variants={varientAbt} animate={detailsPTagInview ? "textAnim":"textInit"} transition={{type:"tween", duration:.5, delay:.5}}>
          We are a studio that designs and realizes adventuresfor the web.
          </motion.p>
          <motion.p variants={varientAbt} animate={detailsPTagInview ? "textAnim":"textInit"} transition={{type:"tween", duration:.5, delay:.7}} className='detailsAccent'>
              We Are woOeNe.</motion.p>
        </div>
        <motion.div className="detailsBGtag" variants={varientAbt} animate={detailsPTagInview ? "show":"hidden"} transition={{duration:1.2}}>
          <img src={bgWithLogo} alt="" />
        </motion.div>
      </section>

      <div id='teamOfficeImgContainer' className="teamOfficeImgContainer " ref={abtBgRef}>
          <img  src={officeImage} alt="" />
          <motion.div variants={varientAbt} animate={abtBgRefInview ? "imgAnim" : "imgInit"} transition={{duration:2}}  className='lazyLoad' ></motion.div>
          <motion.div variants={varientAbt} animate={abtBgRefInview ? "imgAnimColor": "imgInitColor" } transition={{duration:2}}  className='lazyLoadB' ></motion.div>
        </div>

      <section id='team' className="team" ref={teamRef}>
        <motion.p variants={varientAbt} animate={ teamInview ? "theTeamAnim":"theTeamInit"}
        transition={{type:'tween', duration:1 }} 
        className='theTeam'>THE TEAM</motion.p>

        <div className="teamContainer">
          <div id='nasim' className="nasim">
              <div className="left" ref={nasimLeft}>
                <motion.p
                variants={varientAbt} 
                animate={ nasimLeftInview ? "leftAnim":"leftInit"}
                transition={{type:"tween", duration:.5}}
                className='name'>
                  NASIM
                </motion.p>
                <motion.p
                variants={varientAbt}
                animate={ nasimLeftInview ? "leftAnim":"leftInit"}
                transition={{type:"tween", duration:.5}}  
                className='nameDes'>SHANTEAGEO</motion.p>
                <motion.p
                variants={varientAbt}  
                animate={ nasimLeftInview ? "show":"hidden"}
                transition={{type:"tween", duration:.5, delay:.5}}
                className='des'>developer</motion.p>
              </div>
              <div className="right" ref={nasimImgRef} >
                  <img src={nasimImg} alt="" />
                  <motion.div variants={varientAbt} animate={nasimImgInview ? "imgAnim" : "imgInit"} transition={{duration:2}} className='lazyLoad' ></motion.div>
                  <motion.div  variants={varientAbt} animate={nasimImgInview ? "imgAnimColor": "imgInitColor" } transition={{duration:2}} className='lazyLoadB' ></motion.div>
              </div>
          </div>

          <div className="devider">
          </div>

          <div id='oyshi' className="oyshi">
            <div className="left" ref={oyshiImgRef}>
                  <img src={oyshiImg} alt="" />
                  <motion.div variants={varientAbt} animate={oyshiImgInview ? "imgAnimOyshi" : "imgInitOyshi"} transition={{duration:2}} className='lazyLoad' ></motion.div>
                  <motion.div  variants={varientAbt} animate={oyshiImgInview ? "imgAnimColor": "imgInitColor" } transition={{duration:2}} className='lazyLoadB' ></motion.div>
            </div>
            <div className="right" ref={oyshiRight}>
              <motion.p 
                variants={varientAbt} 
                animate={ oyshiRightInview ? "rightAnim":"rightInit"}
                transition={{type:"tween", duration:.5}} className='name' >OYSHI</motion.p>
              <motion.p
                variants={varientAbt}  
                animate={ oyshiRightInview ? "show":"hidden"}
                transition={{type:"tween", duration:.5, delay:.5}}
                className='des'>designer</motion.p>
            </div>
              
          </div>
          <div className="devider">
          </div>

          <div id='nasim' className="nasim">
              <div className="left" ref={sadikLeft}>
                <motion.p
                variants={varientAbt} 
                animate={ sadikLeftInview ? "leftAnim":"leftInit"}
                transition={{type:"tween", duration:.5}}
                className='name'>
                  SADIK
                </motion.p>
                <motion.p
                variants={varientAbt}
                animate={ sadikLeftInview ? "leftAnim":"leftInit"}
                transition={{type:"tween", duration:.5}}  
                className='nameSDes'>AL HASAN</motion.p>
                <motion.p
                variants={varientAbt}  
                animate={ sadikLeftInview ? "show":"hidden"}
                transition={{type:"tween", duration:.5, delay:.5}}
                className='des'>designer</motion.p>
              </div>
              <div className="right" ref={sadikImgRef} >
                  <img src={sadikImg} alt="" />
                  <motion.div variants={varientAbt} animate={sadikImgInview ? "imgAnim" : "imgInit"} transition={{duration:2}} className='lazyLoad' ></motion.div>
                  <motion.div  variants={varientAbt} animate={sadikImgInview ? "imgAnimColor": "imgInitColor" } transition={{duration:2}} className='lazyLoadB' ></motion.div>
              </div>
          </div>

        </div>
      </section>

      <div className="devider">
      </div>

      <section id='codingStyle' className="codingStyle">
        <div className="left" ref={csLeft}>
          <motion.p 
          variants={varientAbt} 
          animate={ csLeftInview ? "leftAnim":"leftInit"}
          transition={{type:"tween", duration:.2}}
          className="codingS">
          <span>&lt;</span>starting<span>&gt;</span>
          </motion.p>
          <motion.p  
            variants={varientAbt}  animate={ csLeftInview ? "textAnim":"textInit"} 
            transition={{type:"tween", duration:.5, delay:.2}}
            className='CSText'>LET'S START <br />THE JOURNEY <br />TOGETHER</motion.p>
          <motion.p variants={varientAbt} animate={ csLeftInview ? "leftAnim":"leftInit"}
            transition={{type:"tween", duration:.2, delay:.7}}
            className="codingS">
            <span>&lt;</span>/ending<span>&gt;</span>
          </motion.p>
        </div>
        <div className="right" ref={csRight}>
          <motion.p 
          variants={varientAbt} 
          animate={ csRightInview ? "textAnim":"textInit"}
          transition={{type:"tween", duration:.5, delay:.7}}
          >Sit back, relax; our team will handle your digital world.
            <br />
            URL or IRL, same difference: getting established online is (almost) as challenging as in real life. Layout, architectural recommendations, network building, interior and exterior design, maintenance... Our team takes care of everything, from design through to project management and execution.
            <br />

          </motion.p>
          <motion.div  
          variants={varientAbt} 
          animate={ csRightInview ? "leftAnim":"leftInit"}
          transition={{type:"tween", duration:.4, delay:1}}
          >
            <Link className='detailLinks' to="/contact">TALK TO<br /> US<img src={linkArrow} alt="" /></Link>
          </motion.div>
        </div>
      </section>

      <div className="devider">
      </div>

    <section id='contactSmall' className="contactSmall">
      <div>
        <h1>*OR MAYBE</h1>
      </div>
      <div className="mail" ref={mailRef}>
        <div className='mailDes'>
          <motion.p
          variants={varientAbt}
          animate={mailInview ? 'leftAnim':"leftInit"}
          transition={{type:"tween", duration:.3}}>Write a Mail</motion.p>
          <motion.p
          variants={varientAbt}
          animate={mailInview ? 'leftAnim':"leftInit"}
          transition={{type:"tween", duration:.3}}>nasim.stg@gmail.com</motion.p>
        </div>
        <motion.div variants={varientAbt}
          animate={mailInview ? 'show':"hidden"}
          transition={{duration:.3, delay:.2}}>
          <img src={mailIcon} alt="mailIcon" />
        </motion.div>
      </div>

      <div className="phone" ref={phoneRef}>
      <motion.div variants={varientAbt}
          animate={phoneInview ? 'show':"hidden"}
          transition={{duration:.3, delay:.2}}>
          <img src={phoneIcon} alt="phoneIcon" />
        </motion.div>
        <div className='mailDes'>
          <motion.p
          variants={varientAbt}
          animate={phoneInview ? 'rightAnim':"rightInit"}
          transition={{type:"tween", duration:.3}}>Give Us a Call</motion.p>
          <motion.p
          variants={varientAbt}
          animate={phoneInview ? 'rightAnim':"rightInit"}
          transition={{type:"tween", duration:.3}}>+8801314091006</motion.p>
        </div>
      </div>
      
    </section>

    <div className="devider">
      </div>

    <section id='contactCard' className="contactCard" ref={contactCard}>
          <motion.div className="c1" variants={varientAbt} animate={contactCardInView ? "show" : "hidden"}
          transition={{type:"Inertia",duration:.5}}
            >
            <div className="cardContainer">
              <div className="cardArrow">
              <svg width="44" height="44" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="workCardArrow__arrow"><path d="M0 7.2124H15.6" stroke="#FFFF31FF" stroke-width="1.5" stroke-miterlimit="10"></path><path d="M9.8999 1L16.0999 7.21289L9.8999 13.4258" stroke="#FFFF31FF" stroke-width="1.5" stroke-miterlimit="10"></path></svg>
              </div>
              <div className="cardTitle">
                <p>&nbsp;</p>
              </div>
                <div className="imgAnimHideDiveBig">
                </div>
            </div>
          </motion.div>
          <motion.div className="c2"  variants={varientAbt} animate={contactCardInView ? "show" : "hidden"}
          transition={{type:"Inertia",duration:.5, delay:.2}}
            >
            <div className="cardContainer">
              <div className="cardArrow">
              <svg width="44" height="44" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="workCardArrow__arrow"><path d="M0 7.2124H15.6" stroke="#FFFF31FF" stroke-width="1.5" stroke-miterlimit="10"></path><path d="M9.8999 1L16.0999 7.21289L9.8999 13.4258" stroke="#FFFF31FF" stroke-width="1.5" stroke-miterlimit="10"></path></svg>
              </div>
              <div className="cardTitle">
                <p>&nbsp;</p>
              </div>
                <div className="imgAnimHideDiveBig">
                </div>
            </div>
          </motion.div>
          <motion.div className="c3" variants={varientAbt} animate={contactCardInView ? "show" : "hidden"}
          transition={{type:"Inertia",duration:.5, delay:.4}}
            >
            <div className="cardContainer">
              <div className="cardArrow">
              <svg width="44" height="44" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="workCardArrow__arrow"><path d="M0 7.2124H15.6" stroke="#FFFF31FF" stroke-width="1.5" stroke-miterlimit="10"></path><path d="M9.8999 1L16.0999 7.21289L9.8999 13.4258" stroke="#FFFF31FF" stroke-width="1.5" stroke-miterlimit="10"></path></svg>
              </div>
              <div className="cardTitle">
                <p>&nbsp;</p>
              </div>
                <div className="imgAnimHideDiveBig">
                </div>
            </div>
          </motion.div>
          <motion.div className="c4" variants={varientAbt} animate={contactCardInView ? "show" : "hidden"}
          transition={{type:"Inertia",duration:.5, delay:.6}}
            >
            <div className="cardContainer">
              <div className="cardArrow">
              <svg width="44" height="44" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="workCardArrow__arrow"><path d="M0 7.2124H15.6" stroke="#FFFF31FF" stroke-width="1.5" stroke-miterlimit="10"></path><path d="M9.8999 1L16.0999 7.21289L9.8999 13.4258" stroke="#FFFF31FF" stroke-width="1.5" stroke-miterlimit="10"></path></svg>
              </div>
              <div className="cardTitle">
                <p>&nbsp;</p>
              </div>
                <div className="imgAnimHideDiveBig">
                </div>
            </div>
          </motion.div>
          <motion.div className="c4"  variants={varientAbt} animate={contactCardInView ? "show" : "hidden"}
          transition={{type:"Inertia",duration:.5, delay:.8}}
            >
            <div className="cardContainer">
              <div className="cardArrow">
              <svg width="44" height="44" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="workCardArrow__arrow"><path d="M0 7.2124H15.6" stroke="#FFFF31FF" stroke-width="1.5" stroke-miterlimit="10"></path><path d="M9.8999 1L16.0999 7.21289L9.8999 13.4258" stroke="#FFFF31FF" stroke-width="1.5" stroke-miterlimit="10"></path></svg>
              </div>
              <div className="cardTitle">
                <p>&nbsp;</p>
              </div>
                <div className="imgAnimHideDiveBig">
                </div>
            </div>
          </motion.div>
          <motion.div className="cf" variants={varientAbt} animate={contactCardInView ? "show" : "hidden"}
          transition={{type:"Inertia",duration:.5, delay:1}}
            >
            <div className="cardContainer">
              <div className="cardArrow">
              <svg width="44" height="44" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="workCardArrow__arrow"><path d="M0 7.2124H15.6" stroke="#FFFF31FF" stroke-width="1.5" stroke-miterlimit="10"></path><path d="M9.8999 1L16.0999 7.21289L9.8999 13.4258" stroke="#FFFF31FF" stroke-width="1.5" stroke-miterlimit="10"></path></svg>
              </div>
              <div className="cardTitle">
                <motion.p variants={varientAbt}  animate={contactCardInView ? "textAnim" : "textInit"}
                transition={{type:"Inertia",duration:.5, delay:1}
          }>HI THERE, YOUNG ENTREPRENEUR</motion.p>
              </div>
                <div className="imgAnimHideDiveBig">
                  <motion.p  variants={varientAbt}  animate={contactCardInView ? "textAnim" : "textInit"}
                transition={{type:"Inertia",duration:.5, delay:1}}>Does our sense of humour float your boat?
                    You are ready to work with or at woOeNe!
                  </motion.p>
                  <motion.p  variants={varientAbt}  animate={contactCardInView ? "textAnim" : "textInit"}
                transition={{type:"Inertia",duration:.5, delay:1}} >If you tick all the boxes,</motion.p>
                  <p>&nbsp;</p>
                  <Link to='/contact' className='btn'>DROP US YOUR MAIL</Link>
                </div>
            </div>
          </motion.div>
            
    </section>

    </div>
  )
}